import React, { createContext, useState } from "react";
import useSignUpAndLogin from "./useSignUpAndLogin";

const LoginContext = createContext({
    isUserLoggedIn: false,
    performLogin(){},
    performLogout(){},
    performSignup(){}
});


function LoginContextProvider(props){
    const {doLogin} = useSignUpAndLogin();
    const [isUserLoggedIn, reverseLoginState] = useState(getAccessTokenFromSessionStorage("isLoggedIn") ?? false);

    function saveAccessTokenInSessionStorage(isLoggedIn){
        sessionStorage.setItem("isLoggedIn", isLoggedIn);
    }
    
    function getAccessTokenFromSessionStorage(propertyName){
        return sessionStorage.getItem(propertyName);
    }

    function removeAccessTokenFromSessionStorage(propertyName){
        sessionStorage.removeItem(propertyName);
    }

    function performLogin({userEmail, userPassword}){
        doLogin({userEmail:userEmail, userPassword:userPassword, isLogin:true}).then((res) =>{
            saveAccessTokenInSessionStorage(true);
            reverseLoginState(prevState => {
                return !prevState;
            })
        }).catch(error => {
            alert("Wrong Email/Password!");
        })
    }

    function performSignup({userEmail, userPassword}){
        doLogin({userEmail:userEmail, userPassword:userPassword, isLogin:false}).then((res) =>{
            alert("Your Account has been Created! Enjoy...")
        }).catch(error => {
            alert("Account Already Exists or Not Valid!");
        })
    }

    function performLogout(){
        removeAccessTokenFromSessionStorage("isLoggedIn");
        reverseLoginState();
    }
    
    return (
        <LoginContext.Provider value={{isUserLoggedIn:isUserLoggedIn, 
        performLogin, performLogout, performSignup}}>
            {props.children}
        </LoginContext.Provider>
    )
}



export {LoginContextProvider};
export default LoginContext;